

import React from 'react'
import './Hero.css'
import ProfileImg from '../Assets/pro.jpg'
import ProfileImg2 from '../Assets/logos.jpg'
import ProfileImg3 from '../Assets/kenphoto.jpg'

const Hero = () => {
  return (
    <div className='container'>
        <div className="hero-container">
            <div className="hero-content">
                <span>Hi <strong>👋</strong></span>
                <h2>Experienced Software Engineer </h2>

                <p>Hello! I'm a results-driven full-stack engineer with a passion for building scalable and efficient web applications. My expertise spans both client and server-side technologies, allowing me to create seamless and dynamic user experiences. Let's turn your ideas into reality with clean, maintainable code and innovative solutions.</p>
            </div>

            <div className="hero-img">
                <div>
                    <div className="tech-icon">
                    <i class="fab fa-css3-alt"></i>
                        {/* <img src={ProfileImg2} alt="" /> */}
                    </div>
                    <img src={ProfileImg} alt="" />
                </div>

                <div>
                    <div className="tech-icon">
                        {/* <img src={ProfileImg3} alt="" /> */}
                        <i class="fab fa-rust"></i>
                    </div>
                    <div className="tech-icon">
                        {/* <img src={ProfileImg} alt="" /> */}
                        <i class="fab fa-python"></i>
                    </div>
                    <div className="tech-icon">
                        {/* <img src={ProfileImg3} alt="" /> */}
                        <i class="fab fa-js-square"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Hero


